import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const RadioCardInput = styled.input`
  font-size: inherit;
  margin: 0;
  position: absolute;
  right: var(--dui-size-space-4x);
  top: var(--dui-size-space-4x);
  @supports (-webkit-appearance: none) or (-moz-appearance: none) {
    & {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: transparent;
      border: var(--dui-size-width-border-xs) solid transparent;
      border-radius: 50%;
      cursor: pointer;
      height: var(--dui-size-space-9x);
      width: var(--dui-size-space-9x);
      outline: none;
      transition: color 0.2s ease-out;
    }
    &:checked {
      background: var(--dui-colors-icons-positive);
    }
    &:checked::after {
      border: 2px solid var(--dui-colors-stroke-inverted);
      border-top: 0;
      border-left: 0;
      content: "";
      display: block;
      height: 1rem;
      width: 0.6rem;
      left: 25%;
      position: absolute;
      top: 45%;
      transform: rotate(45deg) translate(-50%, -50%);
    }
  }
`;

export const RadioCardWrapper = styled.div`
  min-width: var(--dui-size-space-72x);
  border: var(--dui-size-width-border-xs) solid transparent;
  border-radius: var(--dui-size-space-6x);
  position: relative;
  box-shadow: var(--dui-shadow-md-0), var(--dui-shadow-md-1);
  &:has(:focus-visible) {
    outline: var(--dui-size-space-1x) solid
      var(--dui-colors-stroke-functional-focus);
    outline-offset: var(--dui-size-space-1x);
  }
  &:hover {
    box-shadow: var(--dui-shadow-lg-0), var(--dui-shadow-lg-1);
  }
  &:has(${RadioCardInput}:checked) {
    border-color: var(--dui-colors-stroke-positive);
  }
  &:has(${RadioCardInput}:disabled) {
    color: var(--dui-colors-stroke-muted);
    border-color: var(--dui-colors-stroke-muted);

    cursor: default;
  }
  &:has(${RadioCardInput}:disabled):hover {
    box-shadow: none;
  }
`;

export const RadioCardLabel = styled.label`
  cursor: pointer;
  display: grid;
  padding: var(--dui-size-space-12x) var(--dui-size-space-24x);
  transition: border-color 0.2s ease-out;
  line-height: 150%;
  height: 100%;
  dhl-text {
    font-weight: 700;
  }
  grid-template-areas: "image" "title" "description";
  justify-content: center;
`;

export const RadioCardDescription = styled(DhlText)`
  text-align: center;
  grid-area: description;
  span {
    color: var(--dui-colors-foreground-secondary);
    font-size: var(--dui-size-font-sm);
  }
  @media screen and (min-width: ${breakpoints.desktop}) {
    span {
      font-size: var(--dui-size-font-lg);
    }
  }
`;

export const RadioCardTitle = styled(DhlText)`
  grid-area: title;
  text-align: center;
  span {
    font-size: var(--dui-size-font-sm);
  }
  @media screen and (min-width: ${breakpoints.desktop}) {
    span {
      font-size: var(--dui-size-font-3xl);
    }
  }
`;
export const RadioCardsFieldset = styled.fieldset`
  &[aria-invalid="true"] ${RadioCardWrapper} {
    border-color: var(--dui-colors-stroke-negative);
    ${RadioCardTitle} span {
      color: var(--dui-colors-stroke-negative);
    }
  }
`;
export const RadioCardImage = styled.div`
  grid-area: image;
  display: flex;
  justify-content: center;
  align-content: center;
`;
